import styled from 'styled-components';

export const FiltersSetDialogStyles = styled.div`
  color: black;
`;
